import React from 'react'
import ReturnInvoiceListTable from './Componates/ReturnInvoiceListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const ReturnInvoiceList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Return Invoice List</HeadingOne>
          <AddItemBtn url="add-return-invoice" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <ReturnInvoiceListTable />
      </div>
    </PageBody>
  );
};

export default ReturnInvoiceList;
